
export enum QuizHomeView {
    notStarted = 'not-started',
    quiz = 'quiz',
    lastResult = 'lastResult',
    allResults = 'allResults',
    quizAnswers = 'quizAnswers'
}
